import { render, staticRenderFns } from "./DatatableSelectCustomers.vue?vue&type=template&id=60672338&scoped=true&"
import script from "./DatatableSelectCustomers.vue?vue&type=script&lang=js&"
export * from "./DatatableSelectCustomers.vue?vue&type=script&lang=js&"
import style0 from "./DatatableSelectCustomers.vue?vue&type=style&index=0&id=60672338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60672338",
  null
  
)

export default component.exports